const actTemplateValidationScheme = {
  finTermGroupIds: ['oneFinTermRequired'],
  reportTotalExpression: ['required'],
  currency: ['required'],
  payoutPeriod: ['required'],
  reportFileNamePattern: ['forbiddenFileNameSymbols']
};
export default actTemplateValidationScheme;